import { render, staticRenderFns } from "./TableInspectCustom.vue?vue&type=template&id=36fb7d62&scoped=true"
import script from "./TableInspectCustom.vue?vue&type=script&lang=js"
export * from "./TableInspectCustom.vue?vue&type=script&lang=js"
import style0 from "./TableInspectCustom.vue?vue&type=style&index=0&id=36fb7d62&prod&scoped=true&lang=scss"
import style1 from "./TableInspectCustom.vue?vue&type=style&index=1&id=36fb7d62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb7d62",
  null
  
)

export default component.exports